// src/headerTokens.js
const ACCESS_KEY = 'ia_hdr_access';
const REFRESH_KEY = 'ia_hdr_refresh';
const ACCESS_EXPIRES_KEY = 'ia_hdr_access_expires_at';
const REFRESH_EXPIRES_KEY = 'ia_hdr_refresh_expires_at';

// Gebruik een kleine marge zodat een token niet precies tijdens een request verloopt.
const EXPIRY_SKEW_SECONDS = 15;

function nowInSeconds() {
  return Math.floor(Date.now() / 1000);
}

function toPositiveNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function readJwtExpiry(token) {
  if (!token) return 0;

  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return 0;

    const normalized = payloadPart
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(payloadPart.length / 4) * 4, '=');

    const payload = JSON.parse(window.atob(normalized));
    return toPositiveNumber(payload?.exp);
  } catch (_) {
    return 0;
  }
}

function saveExpiry(storageKey, token, expiresIn) {
  const ttl = toPositiveNumber(expiresIn);
  const expiresAt = ttl > 0 ? nowInSeconds() + ttl : readJwtExpiry(token);

  if (expiresAt > 0) {
    sessionStorage.setItem(storageKey, String(expiresAt));
  } else {
    sessionStorage.removeItem(storageKey);
  }
}

function getUsableToken(tokenKey, expiryKey) {
  const token = sessionStorage.getItem(tokenKey) || '';
  if (!token) return '';

  const storedExpiry = toPositiveNumber(sessionStorage.getItem(expiryKey));
  const expiresAt = storedExpiry || readJwtExpiry(token);

  if (expiresAt > 0 && expiresAt <= nowInSeconds() + EXPIRY_SKEW_SECONDS) {
    sessionStorage.removeItem(tokenKey);
    sessionStorage.removeItem(expiryKey);
    return '';
  }

  return token;
}

export function applyHeaderTokensFromResponse(payload = {}) {
  const ht = payload.header_tokens || payload;
  if (!ht || !ht.access) return;

  sessionStorage.setItem(ACCESS_KEY, ht.access);
  saveExpiry(ACCESS_EXPIRES_KEY, ht.access, ht.expires_in);

  // Bij een gewone access-refresh wordt geen nieuw refresh-token teruggegeven.
  // Het bestaande refresh-token moet dan behouden blijven.
  if (ht.refresh) {
    sessionStorage.setItem(REFRESH_KEY, ht.refresh);
    saveExpiry(REFRESH_EXPIRES_KEY, ht.refresh, ht.refresh_expires_in);
  }
}

export function getHeaderAccessToken() {
  return getUsableToken(ACCESS_KEY, ACCESS_EXPIRES_KEY);
}

export function getHeaderRefreshToken() {
  return getUsableToken(REFRESH_KEY, REFRESH_EXPIRES_KEY);
}

export function hasHeaderAuth() {
  return Boolean(getHeaderAccessToken());
}

export function clearHeaderTokens() {
  sessionStorage.removeItem(ACCESS_KEY);
  sessionStorage.removeItem(REFRESH_KEY);
  sessionStorage.removeItem(ACCESS_EXPIRES_KEY);
  sessionStorage.removeItem(REFRESH_EXPIRES_KEY);

  // Opruimen van de sleutel uit de vorige implementatie.
  sessionStorage.removeItem('ia_hdr_expires_at');
}
